import { Navigate } from "react-router-dom";
import { ensureAuthOrRedirect } from "../utils/auth";

export default function ProtectedRoute({ children }) {
  if (!ensureAuthOrRedirect()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}